( function ( $ ) {

	MP.parallax = function(){

		return;

		if( browser.fuie ) return; // parallax looks bad in i.e.
		
		const parallax_bg = document.querySelectorAll('.js-parallax[style^="background"], .js-parallax.m-intro-video-hold');

		parallax_bg.length && [].forEach.call( parallax_bg , function( el ){

			const vid = el.querySelector('video');
			
			lib.on(['load','scroll'] , function(){
				
				if ( ! lib.isScrolledIntoView(el) ) return;
				
				requestAnimationFrame(()=>{
					var formula = window.pageYOffset;
					el.style.backgroundPositionY = (formula * 0.6) +"px";
					if(vid)el.style.top = (formula * 0.6 ) + 'px';
					
				});

			});

		});		

	};

	MP.scrollToSelf = function(){

		$('.scroll-down').each( function(){

			const $it = $(this);

			$it.append( new SvgIcons().render('arr-d'));

			$it.on( 'click', function(){

				$('body,html').animate({scrollTop: window.pageYOffset + this.getBoundingClientRect().top - lib.offset('#wpadminbar,#site-top') },300);

			});

		});
	};

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/a-effects.js